import { cn } from '@/lib/cn'

export function Spinner({
  size = 20,
  className,
  label = 'Загрузка',
}: {
  size?: number
  className?: string
  label?: string
}) {
  return (
    <svg
      className={cn('animate-spin', className)}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      role="status"
      aria-label={label}
    >
      <circle cx={12} cy={12} r={9} stroke="currentColor" strokeOpacity={0.2} strokeWidth={2.5} />
      <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" />
    </svg>
  )
}

/** Индикатор на всю область (загрузка экрана). */
export function PageSpinner() {
  return (
    <div className="flex min-h-[40vh] items-center justify-center text-muted">
      <Spinner size={28} />
    </div>
  )
}
